export default __webpack_public_path__ + "static/media/watch.d3bb2454.svg";